<template>
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.0001 10L2 5.49999L11.0001 1L20 5.49999L11.0001 10Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="40"
      stroke-linecap="square"
    />
    <path
      d="M19.9619 9.64062C18.3493 10.3815 10.9998 13.9983 10.9998 13.9983L2.00293 9.64062"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="40"
      stroke-linecap="square"
    />
    <path
      d="M19.9619 13.6406C18.3493 14.3815 10.9998 17.9983 10.9998 17.9983L2.00293 13.6406"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="40"
      stroke-linecap="square"
    />
  </svg>
</template>
